import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { Filters } from "./types";

export function filterSpecializations(
  filters: Filters,
  specializations: SpecializationDto[]
) {
  const { locations } = filters;
  if (!locations || locations.length == 0) return specializations;

  const availableSpecializations = locations.flatMap(location => (location.specializations));
  
  return specializations.filter((specialization) =>
    availableSpecializations.includes(specialization.id)
  );
}

